import React, { createContext, useContext, useMemo } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import useLocalStorage from './useLocalStorage';
import { getInitials } from '../utils';

const AuthContext = createContext({} as any);

const AuthProvider = ({ children }: any) => {
  const [user, setUser] = useLocalStorage('user', null);

  const navigate = useNavigate();

  const permissions = {
    admin: [
      'menu_dashboard',
      'manage-users',
    ],
  };

  const login = async (data: any) => {
    if (data.email) {
      localStorage.setItem('username', data.name);
    
      setUser(data);

      navigate('/home');
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.clear();
    
    navigate('/login', { replace: true });
  };

  const value = useMemo(
    () => ({
      user,
      login,
      logout,
      permissions
    }),
    [user]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

const useAuth = () => {
  return useContext(AuthContext);
};

export interface AppJwtPayload {
  id?: string;
  email?: string;
  role?: string;
  exp?: number;
  iat?: number;
}

export const getUserFromToken = (): AppJwtPayload | null => {
  const token = localStorage.getItem('authToken');
  if (!token) return null;

  try {
    return jwtDecode<AppJwtPayload>(token);
  } catch {
    return null;
  }
};

export { AuthProvider, useAuth };
